import React from 'react';
import { Tab, Tabs } from 'baseui/tabs-motion';
import Hotkey from './hotkey';
import { Description, HotkeyRow, Row, Symbol } from './styled-components';
type ShortCutItemsT = {
  title: string;
  hotkeys: Array<{
    key: string;
    description: string;
  }>;
};
type PropsT = {
  shortcutList: Array<ShortCutItemsT>;
};
const HotKeyComponent = ({
  shortcutList
}: PropsT) => {
  // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
  const [activeKey, setActiveKey] = React.useState(shortcutList[0].title);
  if (!shortcutList.length) return null;
  return <>
      <Tabs activeKey={activeKey} onChange={({
      activeKey
    }) => {
      // @ts-expect-error todo(ts-migration) TS2345 Argument of type 'Key' is not assignable to parameter of type 'SetStateAction<string>'.
      setActiveKey(activeKey);
    }}>
        {shortcutList.map(currentShortcut => {
        const {
          title,
          hotkeys
        } = currentShortcut;
        return <Tab title={title} key={title}>
              {hotkeys.map(keyboardShortcutData => {
            const {
              key,
              description
            } = keyboardShortcutData;
            return <Row key={key}>
                    {key.split('+').map((value, idx) => {
                return <HotkeyRow key={value}>
                          <Hotkey hotkey={value}></Hotkey>
                          {idx !== key.split('+').length - 1 && <Symbol>+</Symbol>}
                        </HotkeyRow>;
              })}
                    <Description>{description}</Description>
                  </Row>;
          })}
            </Tab>;
      })}
      </Tabs>
    </>;
};
export default HotKeyComponent;